/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import './styles.scss';
import LazyLoad from 'react-lazyload';
import { useDispatch } from 'react-redux';
const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  arrows: false,
  slidesToShow: 1,
  autoplay: true,
  loop: true,
  adaptiveHeight: false,
  fade: true,
  // cssEase: 'linear',
};
function FeaturedNews() {
  let sliderRef = React.createRef();
  const dispath = useDispatch();
  const [articles, setArticles] = useState([]);
  const getArticles = (currentPage = 1, limit = 5) => {
    axios
      .get('/api/v1/articles', {
        params: {
          page: currentPage,
          limit: limit,
        },
      })
      .then(({ data }) => {
        if (data.success) {
          setArticles([...articles, ...data.payload.articles]);
          dispath({
            type: 'SET_LIST_FEATURED_ARTICLE',
            payload: data.payload.articles,
          });
        }
      });
  };

  const next = () => {
    sliderRef.slickNext();
  };
  const previous = () => {
    sliderRef.slickPrev();
  };

  useEffect(() => {
    getArticles();
  }, []);

  return (
    <div className='home-featured mb-50'>
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <div className='featured-slider-1 border-radius-10'>
              <div className='featured-slider-1-items'>
                <Slider {...settings} ref={(c) => (sliderRef = c)}>
                  {articles.length > 0 &&
                    articles.map((article) => {
                      const {
                        title,
                        short_description,
                        slug,
                        thumbnail,
                        id,
                        name_category,
                        created_at,
                        slug_category,
                        background_color_category,
                        is_video_news,
                      } = article;
                      return (
                        <div className='slider-single' key={id}>
                          <div className='row'>
                            <div className='col-lg-6 col-md-12 order-lg-1 order-2 align-center-vertical'>
                              <div className='slider-caption'>
                                <div className='entry-meta meta-0 mb-25'>
                                  <a href={`'/tin-tuc/` + slug_category}>
                                    <span
                                      style={{
                                        backgroundColor:
                                          background_color_category,
                                      }}
                                      className={`post-in color-white font-small`}
                                    >
                                      {name_category}
                                    </span>
                                  </a>
                                </div>
                                <h2 className='post-title'>
                                  <a
                                    href={
                                      `/${
                                        is_video_news === 1
                                          ? 'tin-video'
                                          : 'tin-tuc'
                                      }/` + slug
                                    }
                                  >
                                    {title}
                                  </a>
                                </h2>
                                <div className='entry-meta meta-1 font-small color-grey mt-20 mb-20'>
                                  <span className='post-on'>
                                    <i className='ti-marker-alt'></i>Ngày đăng{' '}
                                    {created_at}
                                  </span>
                                  {/* <span className='time-reading'>
                                    <i className='ti-timer'></i>
                                    
                                  </span> */}
                                  {/* <span className='hit-count'>
                                    <i className='ti-bolt'></i> 159k lượt xem
                                  </span> */}
                                </div>
                                <p className='excerpt font-medium mt-25 mb-25 text-limit-4-row'>
                                  {short_description}
                                </p>
                              </div>
                            </div>
                            <div className='slider-img col-lg-6 order-lg-2 order-1 col-md-12 slider-img-custom'>
                              <div className='img-hover-scale'>
                                <a
                                  href={
                                    `/${
                                      is_video_news === 1
                                        ? 'tin-video'
                                        : 'tin-tuc'
                                    }/` + slug
                                  }
                                  className='img-slider'
                                >
                                  <img src={thumbnail} alt='post-slider' />
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </Slider>
              </div>
              <div className='row'>
                <div className='col-lg-6 col-md-12'>
                  <div className='arrow-cover'>
                    <button
                      type='button'
                      className='button-slick'
                      onClick={previous}
                    >
                      <i className='flaticon-left'></i>
                    </button>
                    <button
                      type='button'
                      className='button-slick'
                      onClick={next}
                    >
                      <i className='flaticon-right'></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeaturedNews;
